export default __webpack_public_path__ + "/_/goose.bb8f4059.png";